import { Box, Link, Typography } from "@mui/material";
import { isString, truncate } from "lodash";
import { useState } from "react";
import { MdExpandLess, MdExpandMore } from "react-icons/md";

interface ReferenceCellProps {
  content: string;
  maxLength?: number;
}

export const ReferenceContentCell = ({
  content,
  maxLength = 150,
}: ReferenceCellProps) => {
  const [expanded, setExpanded] = useState(false);
  const isTextLong = isString(content) && content.length > maxLength;

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <Box>
      <Typography component="div">
        {expanded || !isTextLong
          ? content
          : truncate(content, {
              length: maxLength,
              omission: "...",
            })}
      </Typography>
      {isTextLong && (
        <Link
          component="button"
          variant="body2"
          onClick={toggleExpand}
          sx={{
            mt: 1,
            textDecoration: "none",
            cursor: "pointer",
            color: "primary.main",
            display: "flex",
            alignItems: "center",
          }}
        >
          {expanded ? <MdExpandLess /> : <MdExpandMore />}
          {expanded ? "Show less" : "Show more"}
        </Link>
      )}
    </Box>
  );
};
